import styled from 'styled-components';

export const RemoteSelectContent = styled.div`
  position: relative;
`;

export const RemoteSelectSpinnerContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
